<template>
	<div class="order-info" v-loading="loading">
		<el-card class="box-card" shadow="never">
			<div slot="header" class="clearfix">
				<span class="card-title">保单基本信息</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="goBack">返回列表</el-button>
			</div>

			<el-descriptions :column="2" border>
				<el-descriptions-item label="订单ID">{{ info.id || '-' }}</el-descriptions-item>
				<el-descriptions-item label="订单号">{{ info.order_no || '-' }}</el-descriptions-item>
				<el-descriptions-item label="保单号">{{ info.policy_no || '-' }}</el-descriptions-item>
				<el-descriptions-item label="微信支付订单号">{{ info.transaction_id || '-' }}</el-descriptions-item>
				<el-descriptions-item label="订单状态">
					<el-tag :type="getStatusTagType(info.status)">{{ info.statusText || '-' }}</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="发票状态">
					<el-tag
						:type="getInvoiceTagType(info.invoice_status)">{{ getInvoiceStatusText(info.invoice_status) }}</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="售后状态">
					<el-tag
						:type="getRefundTagType(info.refund_status)">{{ getRefundStatusText(info.refund_status) }}</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="保单金额">¥{{ info.amount || '0.00' }}</el-descriptions-item>
				<el-descriptions-item label="支付时间">{{ info.payment_time || '-' }}</el-descriptions-item>
				<el-descriptions-item label="创建时间">{{ info.created_at || '-' }}</el-descriptions-item>
				<el-descriptions-item label="更新时间">{{ info.updated_at || '-' }}</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<el-card class="box-card" shadow="never" style="margin-top: 20px;">
			<div slot="header" class="clearfix">
				<span class="card-title">保险产品信息</span>
			</div>

			<el-descriptions :column="2" border>
				<el-descriptions-item label="保险产品">{{ info.goods_name || '-' }}</el-descriptions-item>
				<el-descriptions-item label="产品规格">{{ info.goods_specs_name || '-' }}</el-descriptions-item>
				<el-descriptions-item label="规格单价">¥{{ info.goods_specs_price || '0.00' }}</el-descriptions-item>
				<el-descriptions-item label="承保公司">{{ info.insurer_name || '-' }}</el-descriptions-item>
				<el-descriptions-item label="保险起期">{{ info.pln_start_date || '-' }}</el-descriptions-item>
				<el-descriptions-item label="保险止期">{{ info.pln_end_date || '-' }}</el-descriptions-item>
				<el-descriptions-item label="保险天数">{{ info.insured_days || 0 }} 天</el-descriptions-item>
				<el-descriptions-item label="被保人数">{{ info.insuredCount || 0 }} 人</el-descriptions-item>
				<el-descriptions-item label="承保份数">{{ info.pln_copies || 0 }} 份</el-descriptions-item>
				<el-descriptions-item label="短信通知">
					<el-tag :type="info.sms_notify_policyholder ? 'success' : 'info'">
						{{ info.sms_notify_policyholder ? '开启' : '关闭' }}
					</el-tag>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<el-card class="box-card" shadow="never" style="margin-top: 20px;">
			<div slot="header" class="clearfix">
				<span class="card-title">投保人信息</span>
			</div>

			<el-descriptions :column="2" border v-if="applicantInfo">
				<el-descriptions-item label="投保类型">
					<el-tag>{{ applicantInfo.applicant_type_text || '-' }}</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="投保人姓名">{{ applicantInfo.applicant_name || '-' }}</el-descriptions-item>
				<el-descriptions-item
					label="证件类型">{{ applicantInfo.applicant_id_type_text || '-' }}</el-descriptions-item>
				<el-descriptions-item label="证件号码">{{ applicantInfo.applicant_id_number || '-' }}</el-descriptions-item>
				<el-descriptions-item
					label="联系人">{{ applicantInfo.applicant_contact_name || '-' }}</el-descriptions-item>
				<el-descriptions-item label="联系电话">{{ applicantInfo.applicant_phone || '-' }}</el-descriptions-item>
			</el-descriptions>
			<div v-else class="no-data">暂无投保人信息</div>
		</el-card>

		<el-card class="box-card" shadow="never" style="margin-top: 20px;">
			<div slot="header" class="clearfix">
				<span class="card-title">被保险人信息</span>
				<span class="insured-count">共 {{ insuredList.length }} 人</span>
			</div>

			<el-table :data="insuredList" border style="width: 100%" v-if="insuredList.length > 0">
				<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
				<el-table-column prop="isrd_no" label="被保人序号" align="center" width="100"></el-table-column>
				<el-table-column prop="isrd_name" label="被保人姓名" align="center" min-width="120"></el-table-column>
				<el-table-column prop="isrd_telnumber" label="手机号码" align="center" min-width="130"></el-table-column>
				<el-table-column prop="isrd_cret_type_text" label="证件类型" align="center"
					min-width="120"></el-table-column>
				<el-table-column prop="isrd_cret_code" label="证件号码" align="center" min-width="180"></el-table-column>
				<!-- <el-table-column label="状态" align="center" width="100">
					<template slot-scope="scope">
						<el-tag :type="getInsuredStatusTagType(scope.row.status)" size="small">
							{{ getInsuredStatusText(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column> -->
				<el-table-column prop="created_at" label="创建时间" align="center" width="180"></el-table-column>
			</el-table>
			<div v-else class="no-data">暂无被保险人信息</div>
		</el-card>

		<el-card class="box-card" shadow="never" style="margin-top: 20px;">
			<div slot="header" class="clearfix">
				<span class="card-title">保障项目</span>
			</div>

			<div v-if="coveragePlans && coveragePlans.length > 0">
				<el-table :data="coveragePlans" border style="width: 100%">
					<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
					<el-table-column prop="name" label="保障项目" align="center" min-width="150"></el-table-column>
					<el-table-column prop="amount" label="保额" align="center" min-width="120"></el-table-column>
					<el-table-column prop="content" label="保障内容" align="left" min-width="300"
						show-overflow-tooltip></el-table-column>
				</el-table>
			</div>
			<div v-else class="no-data">暂无保障项目信息</div>
		</el-card>
	
			<!-- 太保投保信息 -->
			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">太保投保信息</span>
				</div>
	
				<el-descriptions :column="2" border>
					<el-descriptions-item label="投保状态">
						<el-tag :type="getInsureStatusTagType(info.insure_status)" size="small">
							{{ getInsureStatusText(info.insure_status) }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="重试次数">
						{{ info.insure_retry_count || 0 }} 次
					</el-descriptions-item>
					<el-descriptions-item label="投保单号">{{ info.apply_no || '-' }}</el-descriptions-item>
					<el-descriptions-item label="太保保单号">{{ info.policy_no || '-' }}</el-descriptions-item>
					<el-descriptions-item label="最近错误" :span="2">
						<span class="error-text">{{ info.insure_last_error || '无' }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="电子保单" :span="2">
						<el-link v-if="info.policy_file_url" type="primary" :href="info.policy_file_url" target="_blank">
							点击下载电子保单
						</el-link>
						<span v-else>暂无</span>
					</el-descriptions-item>
				</el-descriptions>
	
				<div style="margin-top: 15px;" v-if="info.insure_status == 3">
					<el-button type="warning" size="small" @click="retryInsure">重新投保</el-button>
				</div>
			</el-card>
	
			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">备注信息</span>
				</div>

			<el-descriptions :column="1" border>
				<el-descriptions-item label="用户备注">
					<div class="remark-content">{{ info.remark || '无' }}</div>
				</el-descriptions-item>
				<el-descriptions-item label="后台备注">
					<div class="remark-content">{{ info.admin_remark || '无' }}</div>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<!-- <div class="action-buttons" style="margin-top: 20px; text-align: center;">
			<el-button @click="goBack">返回</el-button>
			<el-button type="primary" @click="handleSave" v-if="hasEditPermission">保存修改</el-button>
			<el-button type="warning" @click="handlePrint">打印保单</el-button>
			<el-button type="success" @click="handleExport">导出信息</el-button>
		</div> -->
	</div>
</template>

<script>
	export default {
		name: 'OrderInfo',
		props: {
			id: {
				type: [String, Number],
				required: true
			}
		},
		data() {
			return {
				loading: false,
				info: {}
			}
		},
		computed: {
			// 投保人信息
			applicantInfo() {
				return this.info.applicant_info || null;
			},

			// 被保险人列表
			insuredList() {
				return this.info.insured || [];
			},

			// 保障项目
			coveragePlans() {
				return this.info.coverage_plan || [];
			},

			// 编辑权限（根据用户角色判断）
			hasEditPermission() {
				// 这里可以根据实际权限系统进行调整
				return true;
			}
		},
		mounted() {
			this.loadOrderInfo();
		},
		methods: {
			// 加载订单详情
			async loadOrderInfo() {
				this.loading = true;
				try {
					const res = await this.$get('app-order/' + this.id);
					this.info = res.data || {};
				} catch (error) {
					this.$notify.error({
						title: '错误',
						message: error || '加载保单信息失败'
					});
				} finally {
					this.loading = false;
				}
			},

			// 获取状态标签类型
			getStatusTagType(status) {
				const typeMap = {
					0: 'warning', // 待支付
					1: 'info', // 待生效
					2: 'success', // 生效中
					3: '', // 已结束
					4: 'danger' // 已退保
				};
				return typeMap[status] || 'info';
			},

			// 获取发票状态文本
			getInvoiceStatusText(status) {
				const statusMap = {
					0: '未申请',
					1: '申请中',
					2: '已开票'
				};
				return statusMap[status] || '未知';
			},

			// 获取发票状态标签类型
			getInvoiceTagType(status) {
				const typeMap = {
					0: 'info',
					1: 'warning',
					2: 'success'
				};
				return typeMap[status] || 'info';
			},

			// 获取售后状态文本
			getRefundStatusText(status) {
				const statusMap = {
					0: '无售后',
					1: '售后中',
					2: '售后完成'
				};
				return statusMap[status] || '未知';
			},

			// 获取售后状态标签类型
			getRefundTagType(status) {
				const typeMap = {
					0: 'info',
					1: 'warning',
					2: 'success'
				};
				return typeMap[status] || 'info';
			},

			// 获取被保险人状态文本
			getInsuredStatusText(status) {
				const statusMap = {
					1: '待生效',
					2: '生效中',
					3: '已结束',
					4: '已退保'
				};
				return statusMap[status] || '未知';
			},

			// 获取被保险人状态标签类型
			getInsuredStatusTagType(status) {
				const typeMap = {
					1: 'info',
					2: 'success',
					3: '',
					4: 'danger'
				};
				return typeMap[status] || 'info';
			},

			// 保存修改
			handleSave() {
				this.$confirm('确定要保存修改吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 构建保存数据
					const saveData = {
						id: this.info.id,
						admin_remark: this.info.admin_remark
						// 可以根据需要添加其他可编辑字段
					};

					this.$save('app-order', saveData).then(res => {
						this.$success('保存成功');
						this.$emit('save');
					}).catch(err => {
						this.$warning(err || '保存失败');
					});
				});
			},

			// 打印保单
			handlePrint() {
				window.print();
			},

			// 导出信息
			handleExport() {
				this.$message.success('导出功能开发中...');
				// 这里可以实现导出Excel或PDF的功能
			},

			// 投保状态文本
				getInsureStatusText(status) {
					const map = {0: '未投保', 1: '投保中', 2: '已投保', 3: '投保失败'};
					return map[status] || '未知';
				},
	
				// 投保状态标签类型
				getInsureStatusTagType(status) {
					const map = {0: 'info', 1: 'warning', 2: 'success', 3: 'danger'};
					return map[status] || 'info';
				},
	
				// 重新投保
				retryInsure() {
					this.$confirm('确认重新提交投保?', '提示', {type: 'warning'}).then(() => {
						this.$post('app-cpic-policy-retry', {order_id: this.info.id}).then(res => {
							this.$notify({message: '已重新提交投保'});
							this.loadOrderInfo();
						}).catch(err => {
							this.$notify.error({message: err || '操作失败'});
						});
					});
				},
	
				// 返回列表
				goBack() {
					this.$emit('cancel');
				}
		},
		watch: {
			id: {
				immediate: true,
				handler(newVal) {
					if (newVal) {
						this.loadOrderInfo();
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.order-info {
		padding: 20px;

		.box-card {
			margin-bottom: 0;

			.card-title {
				font-size: 16px;
				font-weight: bold;
				color: #303133;
			}

			.insured-count {
				float: right;
				color: #409EFF;
				font-weight: normal;
				font-size: 14px;
			}
		}

		.clearfix:before,
		.clearfix:after {
			display: table;
			content: "";
		}

		.clearfix:after {
			clear: both;
		}

		.no-data {
			text-align: center;
			color: #909399;
			padding: 20px;
			font-style: italic;
		}

		.remark-content {
			min-height: 20px;
			white-space: pre-wrap;
			word-break: break-all;
		}

		.error-text {
			color: #f56c6c;
			font-size: 13px;
			word-break: break-all;
		}

		.action-buttons {
			.el-button {
				margin: 0 10px;
				min-width: 100px;
			}
		}
	}

	// 打印样式
	@media print {
		.order-info {
			.box-card {
				box-shadow: none !important;
				border: 1px solid #ddd;
				margin-bottom: 15px;
			}

			.action-buttons {
				display: none;
			}

			.el-card__header {
				background-color: #f5f7fa !important;
				border-bottom: 1px solid #ddd;
			}

			.insured-count {
				color: #000 !important;
			}
		}
	}
</style>